var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_832:940)","key":0},[React.createElement("path",{"d":"M16.227 15.4546H0.772461V17.0001H16.227V15.4546Z","fill":"#667778","key":0}),React.createElement("path",{"d":"M11.8538 0L2.31836 9.53545V13.9091H6.69201L16.2275 4.37365L11.8538 0ZM6.05063 12.3636H3.86383V10.1768L11.8538 2.18681L14.0406 4.37362L6.05063 12.3636Z","fill":"#667778","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_832:940"},React.createElement("rect",{"width":"17","height":"17","fill":"white"})))]);
}

Pencil.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
